import { type ComponentProps } from 'react';
import { cn } from '@shared/lib/cn';

export type InputProps = ComponentProps<'input'>;

export function Input({ className, type, ...props }: InputProps): React.JSX.Element {
  return (
    <input
      type={type}
      className={cn(
        // Base — 44px to keep WCAG 2.5.5 AA target size.
        'border-input bg-background text-foreground placeholder:text-muted-foreground',
        'flex h-11 w-full rounded-md border px-3 py-2 text-base transition-[border-color,box-shadow] duration-150',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        // Focus — brand-tinted ring, no outer ring-offset (it doubled in
        // touchy mobile keyboards causing visible scroll bands on RTL fields).
        'focus-visible:border-brand focus-visible:ring-brand/40 focus-visible:ring-2 focus-visible:outline-none',
        // Disabled via explicit tokens so the icons-inside-input case stays
        // legible (opacity-50 chains kill SVG strokes).
        'disabled:bg-disabled disabled:text-disabled-foreground disabled:border-disabled disabled:cursor-not-allowed',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/40',
        className,
      )}
      {...props}
    />
  );
}
